const statusColors = {
  withOperator: '#F99956', // orange
  recurring: '#F95656', // red
  noOperator: '#57A4DE', // cyan
  onGoing: '#6EBB7E', // green
  finished: '#808080', // grey
};

export default statusColors;
